import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import logoFull from '@/assets/logo-full.svg';
import { AppFooter } from '@/components/layout/AppFooter';
import { getLegalNotice } from '@/content/legalNotice';

const LegalNotice = () => {
  const { i18n } = useTranslation();
  const content = getLegalNotice(i18n.language);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col">
      <div className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#0880AE] hover:text-[#076A8E] transition-colors mb-8"
          >
            <ArrowLeft size={16} />
            {content.back}
          </Link>

          <img src={logoFull} alt="Velox" className="h-8 mb-8" loading="lazy" />

          <h1 className="text-3xl font-semibold text-[#37699E] font-['Lexend_Deca'] mb-3">{content.title}</h1>
          <p className="text-base text-[#2D3748] mb-2">{content.subtitle}</p>
          <p className="text-sm text-[#5A6B7A] mb-8">{content.lastUpdated}</p>

          <div className="space-y-6">
            {content.sections.map((section) => (
              <section key={section.title} className="bg-white rounded-xl border border-[#DBE2EA] p-6">
                <h2 className="text-xl font-medium text-[#37699E] font-['Lexend_Deca'] mb-3">{section.title}</h2>
                <p className="text-sm text-[#2D3748] whitespace-pre-line leading-relaxed">{section.body}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
      <AppFooter variant="app" />
    </div>
  );
};

export default LegalNotice;
